/* eslint-disable no-undef */

// Returns mock overview data
function getOverviewData() {

    return {
        'USD': {
            "Coinbase": {
                "dailyChange" : 0.1135,
                "totalChange" : 0.3357,
                "dailyPnl": 489.9796,
                "totalPnl": 1449.21,
                "position": 4317.57,
                "holdings" : {
                    "ETH": {
                        "dailyChange": 0.1135,
                        "totalChange" : 0.3357,
                        "dailyPnl": 489.9796,
                        "totalPnl": 1449.21,
                        "position" : 4317.57,
                        "quantity" : 5.75700000,
                        "ticker": "ETH",
                        "name": "Ethereum"
                    }
                }
            },
            "Poloniex": {
                "dailyChange": 0.09122,
                "totalChange" : -0.0789,
                "dailyPnl": 28.462,
                "totalPnl": -24.61,
                "position" : 312.015,
                "holdings" : {
                    "SC": {
                        "dailyChange": 0.09122,
                        "totalChange" : -0.0789,
                        "dailyPnl": 28.462,
                        "totalPnl": -24.61,
                        "position" : 312.015,
                        "quantity" : 15250.00000000,
                        "ticker": "SC",
                        "name": "Siacoin"
                    }
                }
            },
            "BitTrex": {
                "dailyChange": 0.015,
                "totalChange" : -0.178,
                "dailyPnl": 67.21,
                "totalPnl": -1129.04,
                "position" : 6339.71,
                "holdings" : {
                    "BTC": {
                        "dailyChange": 0.015,
                        "totalChange" : 0.2415,
                        "dailyPnl": 85.6533,
                        "totalPnl": 1370.46,
                        "position" : 5710.2,
                        "quantity" : 0.614,
                        "ticker": "BTC",
                        "name": "Bitcoin"
                    },
                    "XRP": {
                        "dailyChange": 0.0286,
                        "totalChange" : -0.41772,
                        "dailyPnl": -18.76,
                        "totalPnl": -259.20,
                        "position" : 629.71,
                        "quantity" : 755.60,
                        "ticker": "XRP",
                        "name": "Ripple"
                    }
                }
            }
        },
        'BTC': {
            "Coinbase": {
                "dailyChange": 0.1135,
                "totalChange" : 0.3357,
                "dailyPnl": 0.05293,
                "totalPnl": 0.15645,
                "position" : 0.46631700,
                "holdings" : {
                    "ETH": {
                        "dailyChange": 0.1135,
                        "totalChange" : 0.3357,
                        "dailyPnl": 0.05293,
                        "totalPnl": 0.15645,
                        "position" : 0.46631700,
                        "quantity" : 5.75700000,
                        "ticker": "ETH",
                        "name": "Ethereum"
                    }
                }
            },
            "Poloniex": {
                "dailyChange": 0.16578,
                "totalChange" : 0.0789,
                "dailyPnl": 0.005368,
                "totalPnl": 0.00264709,
                "position" : 0.03355,
                "holdings" : {
                    "SC": {
                        "dailyChange": 0.16578,
                        "totalChange" : 0.0789,
                        "dailyPnl": 0.005368,
                        "totalPnl": 0.00264709,
                        "position" : 0.03355,
                        "quantity" : 15250.00000000,
                        "ticker": "SC",
                        "name": "Siacoin"
                    }
                }
            },
            "BitTrex": {
                "dailyChange": -0.0134,
                "totalChange" : 0.09912,
                "dailyPnl": -0.00086062,
                "totalPnl": 0.067122,
                "position" : 0.67822611,
                "holdings" : {
                    "BTC": {
                        "dailyChange": 0,
                        "totalChange" : 0,
                        "dailyPnl": 0,
                        "totalPnl": 0,
                        "position" : 0.614,
                        "quantity" : 0.614,
                        "ticker": "BTC",
                        "name": "Bitcoin"
                    },
                    "XRP": {
                        "dailyChange": -0.0134,
                        "totalChange" : 0.0772,
                        "dailyPnl": -0.00086062,
                        "totalPnl": 0.00494082,
                        "position" : 0.064226,
                        "quantity" : 755.60,
                        "ticker": "XRP",
                        "name": "Ripple"
                    }
                }
            }
        }
    }

}


// Returns mock holdings data
function getHoldingsData() {

    return {
        "BTC": {
            "Coinbase": {
                "ETH": {
                    "dailyChange": 0.1135,
                    "totalChange" : 0.3357,
                    "dailyPnl": 0.05293,
                    "totalPnl": 0.15645,
                    "position" : 0.46631700,
                    "quantity" : 5.75700000,
                    "ticker": "ETH",
                    "name": "Ethereum"
                }
            },
            "BitTrex": {
                "BTC": {
                    "dailyChange": 0,
                    "totalChange" : 0,
                    "dailyPnl": 0,
                    "totalPnl": 0,
                    "position" : 0.614,
                    "quantity" : 0.614,
                    "ticker": "BTC",
                    "name": "Bitcoin"
                },
                "XRP": {
                    "dailyChange": -0.0134,
                    "totalChange" : 0.0772,
                    "dailyPnl": -0.00086062,
                    "totalPnl": 0.00494082,
                    "position" : 0.064226,
                    "quantity" : 755.60,
                    "ticker": "XRP",
                    "name": "Ripple"
                }
            },
            "Poloniex": {
                "SC": {
                    "dailyChange": 0.16578,
                    "totalChange" : 0.0789,
                    "dailyPnl": 0.005368,
                    "totalPnl": 0.00264709,
                    "position" : 0.03355,
                    "quantity" : 15250.00000000,
                    "ticker": "SC",
                    "name": "Siacoin"
                }
            },
            "All": {                
                "SC": {
                    "dailyChange": 0.16578,
                    "totalChange" : 0.0789,
                    "dailyPnl": 0.005368,
                    "totalPnl": 0.00264709,
                    "position" : 0.03355,
                    "quantity" : 15250.00000000,
                    "ticker": "SC",
                    "name": "Siacoin"
                },
                "BTC": {
                    "dailyChange": 0,
                    "totalChange" : 0,
                    "dailyPnl": 0,
                    "totalPnl": 0,
                    "position" : 0.614,
                    "quantity" : 0.614,
                    "ticker": "BTC",
                    "name": "Bitcoin"
                },
                "XRP": {
                    "dailyChange": -0.0134,
                    "totalChange" : 0.0772,
                    "dailyPnl": -0.00086062,
                    "totalPnl": 0.00494082,
                    "position" : 0.064226,
                    "quantity" : 755.60,
                    "ticker": "XRP",
                    "name": "Ripple"
                },
                "ETH": {
                    "dailyChange": 0.1135,
                    "totalChange" : 0.3357,
                    "dailyPnl": 0.05293,
                    "totalPnl": 0.15645,
                    "position" : 0.46631700,
                    "quantity" : 5.75700000,
                    "ticker": "ETH",
                    "name": "Ethereum"
                }
            }
        },
        "USD": {
            "Coinbase": {
                "ETH": {
                    "dailyChange": 0.1135,
                    "totalChange" : 0.3357,
                    "dailyPnl": 489.9796,
                    "totalPnl": 1449.21,
                    "position" : 4317.57,
                    "quantity" : 5.75700000,
                    "ticker": "ETH",
                    "name": "Ethereum"
                }
            },
            "BitTrex": {
                "BTC": {
                    "dailyChange": 0.015,
                    "totalChange" : 0.2415,
                    "dailyPnl": 85.6533,
                    "totalPnl": 1370.46,
                    "position" : 5710.2,
                    "quantity" : 0.614,
                    "ticker": "BTC",
                    "name": "Bitcoin"
                },
                "XRP": {
                    "dailyChange": 0.0286,
                    "totalChange" : -0.41772,
                    "dailyPnl": -18.76,
                    "totalPnl": -259.20,
                    "position" : 629.71,
                    "quantity" : 755.60,
                    "ticker": "XRP",
                    "name": "Ripple"
                }
            },
            "Poloniex": {
                "SC": {
                    "dailyChange": 0.09122,
                    "totalChange" : -0.0789,
                    "dailyPnl": 28.462,
                    "totalPnl": -24.61,
                    "position" : 312.015,
                    "quantity" : 15250.00000000,
                    "ticker": "SC",
                    "name": "Siacoin"
                }
            },
            "All": {
                "SC": {
                    "dailyChange": 0.09122,
                    "totalChange" : -0.0789,
                    "dailyPnl": 28.462,
                    "totalPnl": -24.61,
                    "position" : 312.015,
                    "quantity" : 15250.00000000,
                    "ticker": "SC",
                    "name": "Siacoin"
                },
                "BTC": {
                    "dailyChange": 0.015,
                    "totalChange" : 0.2415,
                    "dailyPnl": 85.6533,
                    "totalPnl": 1370.46,
                    "position" : 5710.2,
                    "quantity" : 0.614,
                    "ticker": "BTC",
                    "name": "Bitcoin"
                },
                "XRP": {
                    "dailyChange": 0.0286,
                    "totalChange" : -0.41772,
                    "dailyPnl": -18.76,
                    "totalPnl": -259.20,
                    "position" : 629.71,
                    "quantity" : 755.60,
                    "ticker": "XRP",
                    "name": "Ripple"
                },
                "ETH": {
                    "dailyChange": 0.1135,
                    "totalChange" : 0.3357,
                    "dailyPnl": 489.9796,
                    "totalPnl": 1449.21,
                    "position" : 4317.57,
                    "quantity" : 5.75700000,
                    "ticker": "ETH",
                    "name": "Ethereum"
                }
            }
        }
    }

}

    // Returns the mock order data
    function getOrderData() {

        return {
            "Poloniex": {
                "success": true,
                "data": {}
            },
            "Coinbase": {
                "success": true,
                "data": {}
            },
            "BitTrex": {
                "success": true,
                "data": {
                    "11f0f5a7-740b-4772-a83f-e1bb00516372": {
                        "id": "11f0f5a7-740b-4772-a83f-e1bb00516372",
                        "type": "sell",
                        "orderType": "LIMIT_SELL",
                        "baseCurrency": "XRP",
                        "quoteCurrency": "BTC",
                        "price": "0.00008186",
                        "volume": 5500,
                        "leverage": 1,
                        "total": "0.45023000",
                        "fee": 0,
                        "status": "open",
                        "timestamp": 1515639972217,
                        "meta": {
                            "expiretm": null,
                            "misc": null,
                            "oflags": null,
                            "refid": null,
                            "description": null
                        }
                    }
                }
            },
            "Kraken": {
                "success": true,
                "data": {
                    "1517634030211": {
                        "id": "O3AJIK-UX6KS-YIFUY3",
                        "type": "buy",
                        "orderType": "limit",
                        "baseCurrency": "BTC",
                        "quoteCurrency": "USD",
                        "price": "7840.00",
                        "volume": "1.50000000",
                        "leverage": 1,
                        "total": "11760.00",
                        "fee": "0.00000",
                        "status": "open",
                        "timestamp": 1517634030211,
                        "meta": {
                            "expiretm": 0,
                            "misc": "",
                            "oflags": "fciq",
                            "refid": null,
                            "description": "buy 1.50000000 XBTUSD @ limit 7840.0"
                        }
                    }
                }
            }
        };

    }

    // Returns the mock margin positions
    function getMarginData() {

        return {
            "Poloniex": {
                "success": true,
                "data": {}
            },
            "Coinbase": {
                "success": true,
                "data": {}
            },
            "BitTrex": {
                "success": true,
                "data": {}
            },
            "Kraken": {
                "success": true,
                "data": {
                    "1513750540912": {
                        "id": "TWVFM2-X5JNC-BLLEP2",
                        "type": "buy",
                        "orderType": "limit",
                        "baseCurrency": "BTC",
                        "quoteCurrency": "USD",
                        "price": "16050.00",
                        "volume": 0.31240424,
                        "leverage": 2,
                        "total": "5014.09",
                        "fee": 8.52395,
                        "status": "open",
                        "margin": "2407.50",
                        "timestamp": 1513750540912,
                        "meta": {
                            "rollovertm": "1517693111",
                            "misc": "",
                            "oflags": "",
                            "terms": "0.0100% per 4 hours",
                            "ordertxid": "OMVTVA-AQETR-GBR7H2",
                            "volclosed": "0.01240424"
                        }
                    },
                    "1513883736904": {
                        "id": "TG537W-JZBVN-YEIOLB",
                        "type": "buy",
                        "orderType": "limit",
                        "baseCurrency": "BTC",
                        "quoteCurrency": "USD",
                        "price": "14500.00",
                        "volume": 0.5,
                        "leverage": 2,
                        "total": "7250.00",
                        "fee": 12.325,
                        "status": "open",
                        "margin": "3625.00",
                        "timestamp": 1513883736904,
                        "meta": {
                            "rollovertm": "1517693111",
                            "misc": "",
                            "oflags": "",
                            "terms": "0.0100% per 4 hours",
                            "ordertxid": "OZG3GP-XWEW2-R6ES3N",
                            "volclosed": "0.00000000"
                        }
                    }
                }
            }
        };

    }

    // Returns the mock hist pnl bar chart data
    function getDailyPnlData() {
        return {
            'USD' : [
                { date: '1518609600000', value: 211.26, change: 3.25, total: 6500.45 },
                { date: '1518696000000', value: -250.25, change: -4.01, total: 6250.27 },
                { date: '1518782400000', value: 349.78, change: 5.29, total: 6600.48 },
                { date: '1518868800000', value: 200, change: 3.11, total: 6800.37 },
                { date: '1518955200000', value: 120, change: 1.88, total: 6920.66 },
                { date: '1519041600000', value: 710, change: 8.25, total: 10630.00 },
                { date: '1519128000000', value: -425, change: -3.51, total: 9575.00 },
                { date: '1519214400000', value: 50, change: 1.32, total: 9625.00 },
                { date: '1519300800000', value: 110, change: 4.45, total: 9735.00 },
                { date: '1519387200000', value: 225, change: 6.22, total: 9960.00 }
            ],
            'BTC' : [
                { date: '1504497600000', value: 0.13476849, change: 2.56, total: 0.25000000 },
                { date: '1504584000000', value: -0.13476849, change: -4.25, total: 0.25000000 },
                { date: '1504670400000', value: 0.13476849, change: 0.68, total: 0.25000000 },
                { date: '1504756800000', value: -0.13476849, change: 4.45, total: 0.25000000},
                { date: '1504843200000', value: 0.13476849, change: 7.23, total: 0.25000000 },
                { date: '1504929600000', value: -0.13476849, change: 0.81, total: 0.25000000 },
                { date: '1505829600000', value: 0.13476849, change: -3.51, total: 0.25000000 },
                { date: '1505016000000', value: 0.13476849, change: 1.32, total: 0.25000000 },
                { date: '1505102400000', value: 0.13476849, change: 4.45, total: 0.25000000 },
                { date: '1505188800000', value: 0.13476849, change: 6.22, total: 0.25000000 }
            ]
        }

    }

    // Returns the mock hist pnl bar chart data
    function getHistPnlData() {
        return {
            'USD' : [
                { date: '1518609600000', value: 0, change: 3.25, total: 6500.45 },
                { date: '1518696000000', value: -1000, change: -4.01, total: 6250.27 },
                { date: '1518782400000', value: -600, change: 5.29, total: 6600.48 },
                { date: '1518868800000', value: 750, change: 3.11, total: 6800.37 },
                { date: '1518955200000', value: 2250, change: 1.88, total: 6920.66 },
                { date: '1519041600000', value: 2100, change: 8.25, total: 10630.00 },
                { date: '1519128000000', value: 3250, change: -3.51, total: 9575.00 },
                { date: '1519214400000', value: 2250, change: 1.32, total: 9625.00 },
                { date: '1519300800000', value: 2750, change: 4.45, total: 9735.00 },
                { date: '1519387200000', value: 3100, change: 6.22, total: 9960.00 }
            ],
            'BTC' : [
                { date: '1504497600000', value: 0.05, change: 2.56, total: 0.25000000 },
                { date: '1504584000000', value: -0.025, change: -4.25, total: 0.25000000 },
                { date: '1504670400000', value: 0.1, change: 0.68, total: 0.25000000 },
                { date: '1504756800000', value: -0.08, change: 4.45, total: 0.25000000},
                { date: '1504843200000', value: 0.13476849, change: 7.23, total: 0.25000000 },
                { date: '1504929600000', value: -0.01, change: 0.81, total: 0.25000000 },
                { date: '1505829600000', value: 0.13476849, change: -3.51, total: 0.25000000 },
                { date: '1505016000000', value: -0.13476849, change: 1.32, total: 0.25000000 },
                { date: '1505102400000', value: 0.13476849, change: 4.45, total: 0.25000000 },
                { date: '1505188800000', value: -0.13476849, change: 6.22, total: 0.25000000 }
            ]
        }

    }


    // Returns the mock currency history
    function getCurrencyHistoryData() {
        return {
            'BTC' : {
                'ETH': [
                        { date: '1504497600000', value: 0.25240324, change: 2.56 },
                        { date: '1504584000000', value: 0.35240324, change: -4.25 },
                        { date: '1504670400000', value: 0.41230324, change: 0.68 },
                        { date: '1504756800000', value: 0.37240654, change: 4.45 },
                        { date: '1504843200000', value: 0.25240327, change: 7.23 },
                        { date: '1504929600000', value: 0.31240327, change: 0.81 },
                        { date: '1505829600000', value: 0.29534527, change: -3.51 },
                        { date: '1505016000000', value: 0.25240327, change: 1.32 },
                        { date: '1505102400000', value: 0.48932173, change: 4.45 },
                        { date: '1505188800000', value: 0.37524088, change: 6.20 }
                    ],
                'BTC': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: -10, change: -4.25 },
                        { date: '1504670400000', value: -25, change: 0.68 },
                        { date: '1504756800000', value: 25, change: 4.45 },
                        { date: '1504843200000', value: 97, change: 7.23 },
                        { date: '1504929600000', value: 101, change: 0.81 },
                        { date: '1505829600000', value: 101, change: -3.51 },
                        { date: '1505016000000', value: 104, change: 1.32 },
                        { date: '1505102400000', value: 71, change: 4.45 },
                        { date: '1505188800000', value: 65, change: 6.20 }
                    ],
                'LTC': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: -10, change: -4.25 },
                        { date: '1504670400000', value: -25, change: 0.68 },
                        { date: '1504756800000', value: 25, change: 4.45 },
                        { date: '1504843200000', value: 97, change: 7.23 },
                        { date: '1504929600000', value: 101, change: 0.81 },
                        { date: '1505829600000', value: 101, change: -3.51 },
                        { date: '1505016000000', value: 104, change: 1.32 },
                        { date: '1505102400000', value: 71, change: 4.45 },
                        { date: '1505188800000', value: 65, change: 6.20 }
                    ],
                'GNO': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: 10, change: -4.25 },
                        { date: '1504670400000', value: 12, change: 0.68 },
                        { date: '1504756800000', value: 20, change: 4.45 },
                        { date: '1504843200000', value: 8, change: 7.23 },
                        { date: '1504929600000', value: -16, change: 0.81 },
                        { date: '1505829600000', value: 56, change: -3.51 },
                        { date: '1505016000000', value: 98, change: 1.32 },
                        { date: '1505102400000', value: 175, change: 4.45 },
                        { date: '1505188800000', value: 225, change: 6.20 }
                    ]
            },
            'USD' : {
                'ETH': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: 25, change: -4.25 },
                        { date: '1504670400000', value: 42, change: 0.68 },
                        { date: '1504756800000', value: 110, change: 4.45 },
                        { date: '1504843200000', value: 97, change: 7.23 },
                        { date: '1504929600000', value: 101, change: 0.81 },
                        { date: '1505829600000', value: 101, change: -3.51 },
                        { date: '1505016000000', value: 124, change: 1.32 },
                        { date: '1505102400000', value: 165, change: 4.45 },
                        { date: '1505188800000', value: 209, change: 6.20 }
                    ],
                'BTC': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: -10, change: -4.25 },
                        { date: '1504670400000', value: -25, change: 0.68 },
                        { date: '1504756800000', value: 25, change: 4.45 },
                        { date: '1504843200000', value: 97, change: 7.23 },
                        { date: '1504929600000', value: 101, change: 0.81 },
                        { date: '1505829600000', value: 101, change: -3.51 },
                        { date: '1505016000000', value: 104, change: 1.32 },
                        { date: '1505102400000', value: 71, change: 4.45 },
                        { date: '1505188800000', value: 65, change: 6.20 }
                    ],
                'LTC': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: 10, change: -4.25 },
                        { date: '1504670400000', value: 12, change: 0.68 },
                        { date: '1504756800000', value: 20, change: 4.45 },
                        { date: '1504843200000', value: 8, change: 7.23 },
                        { date: '1504929600000', value: -16, change: 0.81 },
                        { date: '1505829600000', value: 56, change: -3.51 },
                        { date: '1505016000000', value: 98, change: 1.32 },
                        { date: '1505102400000', value: 175, change: 4.45 },
                        { date: '1505188800000', value: 225, change: 6.20 }
                    ],
                'GNO': [
                        { date: '1504497600000', value: 0, change: 2.56 },
                        { date: '1504584000000', value: 10, change: -4.25 },
                        { date: '1504670400000', value: 12, change: 0.68 },
                        { date: '1504756800000', value: 20, change: 4.45 },
                        { date: '1504843200000', value: -10, change: -7.23 },
                        { date: '1504929600000', value: -16, change: -1.81 },
                        { date: '1505829600000', value: -35, change: -13.51 },
                        { date: '1505016000000', value: -16, change: 8.32 },
                        { date: '1505102400000', value: -78, change: -22.45 },
                        { date: '1505188800000', value: -136, change: -14.20 }
                    ]
            }
            
        };
    }

    function getTradeHistoryData() {

        return {
                "366142460" : {
                    "totalUSD" : 16.770722931788672, 
                    "cryptoCurrency" : "BCH", 
                    "fee" : "0.00150000", 
                    "price" : "0.15074505", 
                    "total" : "0.00180894", 
                    "volume" : "0.01200000", 
                    "exchange" : "Poloniex", 
                    "time" : 1524852935000, 
                    "type" : "buy", 
                    "tradeCurrency" : "BTC"
                }, 
                "366142506" : {
                    "totalUSD" : 7.25615095969078, 
                    "cryptoCurrency" : "BCH", 
                    "fee" : "0.00150000", 
                    "price" : "0.15060380", 
                    "total" : "0.00078267", 
                    "volume" : "0.00519686", 
                    "exchange" : "Poloniex", 
                    "time" : 1524852964000, 
                    "type" : "sell", 
                    "tradeCurrency" : "BTC"
                }, 
                "366142708" : {
                    "totalUSD" : 7.9964115361893215, 
                    "cryptoCurrency" : "SC", 
                    "fee" : "0.00250000", 
                    "price" : "0.00000321", 
                    "total" : "0.00086370", 
                    "volume" : "269.06542056", 
                    "exchange" : "Poloniex", 
                    "time" : 1524853041000, 
                    "type" : "buy", 
                    "tradeCurrency" : "BTC"
                }, 
                "366142885" : {
                    "totalUSD" : 9.326461879235469, 
                    "cryptoCurrency" : "SC", 
                    "fee" : "0.00250000", 
                    "price" : "0.00000321", 
                    "total" : "0.00100736", 
                    "volume" : "313.81931464", 
                    "exchange" : "Poloniex", 
                    "time" : 1524853124000, 
                    "type" : "buy", 
                    "tradeCurrency" : "BTC"
                }, 
                "361078435" : {
                    "totalUSD" : 15.314000000227999, 
                    "total" : "0.00190000", 
                    "fee" : "0.00150000", 
                    "price" : "0.00000190", 
                    "tradeCurrency" : "BTC", 
                    "volume" : "1000.00000000", 
                    "cryptoCurrency" : "SC", 
                    "time" : 1523629668000, 
                    "type" : "sell", 
                    "exchange" : "Poloniex"
                }, 
                "366142386" : {
                    "totalUSD" : 17.444633536845622, 
                    "cryptoCurrency" : "BTM", 
                    "fee" : "0.00250000", 
                    "price" : "0.00006931", 
                    "total" : "0.00188163", 
                    "volume" : "27.14810242", 
                    "exchange" : "Poloniex", 
                    "time" : 1524852898000, 
                    "type" : "sell", 
                    "tradeCurrency" : "BTC"
                }, 
                "366142470" : {
                    "totalUSD" : 0.6303368006303758, 
                    "cryptoCurrency" : "BCH", 
                    "fee" : "0.00150000", 
                    "price" : "0.15074505", 
                    "total" : "0.00006799", 
                    "volume" : "0.00045102", 
                    "exchange" : "Poloniex", 
                    "time" : 1524852939000, 
                    "type" : "buy", 
                    "tradeCurrency" : "BTC"
                }
            };
    }

    const SampleDataStore = { getOverviewData, getHoldingsData, getOrderData, getMarginData, getDailyPnlData, getHistPnlData, getCurrencyHistoryData, getTradeHistoryData };
    export default SampleDataStore;


// WEBPACK FOOTER //
// ./src/Stores/SampleDataStore.js